module.exports = __webpack_public_path__ + "fonts/iconfont.d4338de3.eot";